/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * String representing the environment.
 */
export const EnvironmentMode = {
  Test: "test",
  Prod: "prod",
  Sandbox: "sandbox",
} as const;
/**
 * String representing the environment.
 */
export type EnvironmentMode = ClosedEnum<typeof EnvironmentMode>;

/** @internal */
export const EnvironmentMode$inboundSchema: z.ZodNativeEnum<
  typeof EnvironmentMode
> = z.nativeEnum(EnvironmentMode);
/** @internal */
export const EnvironmentMode$outboundSchema: z.ZodNativeEnum<
  typeof EnvironmentMode
> = EnvironmentMode$inboundSchema;
